<template>
    <div class="grey-bg">
        <top-carousel></top-carousel>
        <div class="InBusinessList03 InBusinessconSwitch page-content">
            <ul class="clearfix">
                <li v-for="item in list" :key="item.title">
                    <div class="li-box">
                        <p class="img">
                            <img
                                :src="item.url"
                                @click="checkDetail(item.id)"
                            />
                        </p>
                        <div class="img-desc">
                            <h5>{{ item.title }}</h5>
                            <p class="hsh-p">{{ item.desc }}<br /></p>
                            <div class="morenews" @click="checkDetail(item.id)">
                                更多详情&gt;
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            list: [
                {
                    url: require('../../../../assets/img/product/GXJF.png'),
                    title: '高效机房系统',
                    desc: '高效机房建设是一个完整的链条，包括这五个系统的统一:空调设备的选择、优化的设计、稳定的系统控制、安装施工和智能调试运行维护。一个高效机房的效果必须涵盖这五点，同时也要考验承包商是否有能力将五者完美结合。',
                    id: 'gxjf',
                },
                {
                    url: require('../../../../assets/img/product/auto.jpg'),
                    title: '自动化系统',
                    desc: '暖通和动力系统自动控制；工艺流程自动化系统；TIA全集成自动化系统。冷冻站的模糊控制系统和P3实验室控制系统已申请国家专利。',
                    id: 'zdhxt',
                },
                {
                    url: require('../../../../assets/img/product/dig.jpg'),
                    title: '数字化系统',
                    desc: '将自动化、智能化、BIM技术、信息化技术融合产生了数字化工厂、数字化医院、数字化园区。数字化系统从自动化底层的生产管控、质量控制、设备控制、能耗和物料监测到顶层的设备级、系统级和产业级制造、产品全生命周期、设备全生命周期仿真及分析，并将结果反馈回系统，降低生产的不确定性因素，推动了企业提质增效降本。',
                    id: 'szhxt',
                },
                {
                    url: require('../../../../assets/img/product/energy.jpg'),
                    title: '能源管理系统',
                    desc: '能源管理平台建立在底层设备控制和能量计量的基础上，为建筑能源管理和节能策略提供平台。',
                    id: 'nyglxt',
                },
            ],
        }
    },
    methods: {
        checkDetail(id) {
            this.$router.push('/productDetail/' + id)
        },
    },
}
</script>

<style scoped lang="less">
.InBusinessconSwitch {
    margin-top: 42px;
    overflow: hidden;
}
.InBusinessList03 ul li {
    width: 50%;
    overflow: hidden;
    float: left;
    position: relative;
    margin-bottom: 30px;
    &:nth-child(2n) {
        padding-left: 10px;
    }
    &:nth-child(2n + 1) {
        padding-right: 10px;
    }
}
.li-box {
    background: #fff;
}
.InBusinessList03 ul li .img {
    width: 100%;
    height: 294px;
    display: block;
    overflow: hidden;
}
.InBusinessList03 ul li .img img {
    width: 100%;
    height: 100%;
    transition: all ease 2s;
    cursor: pointer;
    &:hover {
        transform: scale(1.1);
    }
}
.InBusinessList01 ul h5,
.InBusinessList03 ul li h5 {
    color: #333;
    padding: 20px 0 0;
    font-size: 18px;
    line-height: 42px;
}
.hsh-p {
    font-size: 14px;
    height: 35px;
    line-height: 24px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #999;
}
div.morenews {
    font-size: 14px;
    color: #999;
    cursor: pointer;
    &:hover {
        color: #555;
    }
    color: #0a439e;
    line-height: 24px;
    margin-top: -4px;
}
.img-desc {
    height: 138px;
    padding: 0 34px 0 25px;
}
</style>
